module.exports = __webpack_public_path__ + "img/zanorari06.dcc7e0fd.jpg";